<template>
  <div class="app-product-aid-swipe-actions">
    <button
      class="app-product-aid-swipe-actions__button app-product-aid-swipe-actions__button--dislike"
      :disabled
      @click="$emit('dislike')"
    >
      <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.2181 16.2179L10.8122 10.8119M10.8122 10.8119L5.40625 16.2179M10.8122 10.8119L5.40625 5.40601M10.8122 10.8119L16.2181 5.40601"
          stroke="black"
          stroke-width="2.2842"
          stroke-linecap="round"
        />
      </svg>
    </button>

    <button
      class="app-product-aid-swipe-actions__button app-product-aid-swipe-actions__button--like"
      :disabled
      @click="$emit('like')"
    >
      <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M19.2367 1.51213C18.1941 0.536987 16.8329 0 15.403 0C13.8621 0 12.3735 0.641343 11.3184 1.76001L10.5009 2.6278L9.68247 1.75955C8.6278 0.641343 7.13918 0 5.59809 0C4.1682 0 2.80674 0.536987 1.76339 1.51236C-0.48745 3.62069 -0.59842 7.16098 1.51625 9.4043C1.52226 9.41052 1.52827 9.41696 1.53451 9.42295L9.92545 17.7646C10.0834 17.9217 10.2903 18 10.4969 18C10.7036 18 10.9105 17.9214 11.0682 17.7648L19.4647 9.42295C19.4709 9.41696 19.4772 9.41052 19.483 9.4043C21.5983 7.16236 21.4878 3.62207 19.2367 1.51213ZM3.8413 8.20823C3.75114 8.2983 3.63277 8.34322 3.5144 8.34322C3.39603 8.34322 3.27766 8.2983 3.1875 8.20823C1.6871 6.71314 1.68687 4.28046 3.18727 2.7856C3.3676 2.60569 3.66074 2.60569 3.84107 2.7856C4.02162 2.96552 4.02162 3.25717 3.84107 3.43708C2.70131 4.5728 2.70155 6.4208 3.8413 7.55675C4.02209 7.73666 4.02209 8.02854 3.8413 8.20823Z"
          fill="black"
        />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    disabled?: boolean;
  }>();

  defineEmits<{
    like: [];
    dislike: [];
  }>();
</script>

<style lang="postcss" scoped>
  .app-product-aid-swipe-actions {
    display: flex;
    justify-content: space-between;

    width: 100%;
    max-width: 260px;
    margin: 0 auto;
    padding: var(--spacing-12) 0 var(--spacing-6);

    &__button {
      cursor: pointer;

      display: flex;
      align-items: center;
      justify-content: center;

      width: var(--spacing-14);
      height: var(--spacing-14);
      border: 0;
      border-radius: 50%;

      transition: transform 0.2s;

      &:disabled {
        cursor: not-allowed;
        opacity: 0.4;
      }

      &:not(:disabled):hover {
        transform: scale(1.1);
      }

      &:not(:disabled):active {
        transform: scale(0.95);
      }

      &--dislike {
        color: var(--colors-black);
        background: #ff7b16;
        box-shadow:
          0 18.02px 22.525px -4.505px rgb(0 0 0 / 10%),
          0 9.01px 9.01px -4.505px rgb(0 0 0 / 4%);
      }

      &--like {
        color: var(--colors-black);
        background: #55e12c;
        box-shadow:
          0 18.02px 22.525px -4.505px rgb(0 0 0 / 10%),
          0 9.01px 9.01px -4.505px rgb(0 0 0 / 4%);
      }
    }
  }
</style>
